import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth relies solely on the httpOnly "session_token" cookie (set by the backend).
// withCredentials ensures the cookie is sent on every request. No token is kept in JS (XSS-safe).
const api = axios.create({ baseURL: API, withCredentials: true });

export default api;
